<template>
  <div class="d-flex justify-center align-center flex-column main pa-16 ">
    <!-- <p class="white--text display-1 text-center">Скидка 10% при оплате за месяц</p> -->
    <v-btn to="/signUp" color="alert" class="white--text mb-6"> Записаться </v-btn>
     <p class="white--text"> Сделано в Кубит </p>
  </div>
</template>

<script>
export default {
  data: () => ({}),
};
</script>


<style lang="scss" scoped>
.v-btn {
  
  animation: btn_scale 5s ease infinite;
}

</style>